import React, { Component } from 'react';
import {Dialog, DialogTitle,DialogContent,DialogContentText,DialogActions,TextField  } from '@material-ui/core';
import Button from '../../../Common/VMButton';
import './EditHashTagDialog.scss';
import i18n from '../../../i18n';

import { connect } from 'react-redux'
import { GetRecommendedHashtag } from '../../../utils/GlobalHashtag'

class EditHashTagDialog extends Component {
    enterKey = () => {
        if(window.event.code  === "Enter"){
            this.props.onConfirm() 
        }
        return
    }

    handleClickRecommendedHashTag = hashtag => {
        const {
            hashtags,
            onChange
        } = this.props

        if (hashtags) {
            if (hashtags.includes(hashtag)) return
            onChange(hashtags + hashtag)
        }
        else onChange(hashtag)
    }

    render() {
        const { 
            open,
            hashtags,
            onClose,
            onConfirm,
            onChange,
            lang
        } = this.props

        return (
            <div onKeyPress={this.enterKey}>
                <Dialog open={open}>
                    <div className="edit-hashtag-dialog-container">
                        <div className="edit-hashtag-dialog-title" id="new-template-desc">
                            {i18n.t("web.edit.hashtag.dialog.title")}
                        </div>

                        <div className="edit-hashtag-dialog-input-container">
                            <input
                                type="text"
                                placeholder={i18n.t("web.edit.hashtag.dialog.input.placeholder")}
                                onChange={e => onChange(e.target.value)}
                                value={hashtags}
                            />
                        </div>
                        <div className="edit-hashtag-dialog-recommended-container">
                            <span className="recommeded-title">{`${i18n.t("web.edit.hashtag.dialog.recommended.hashtag")} : `}</span>
                            {
                                GetRecommendedHashtag(lang).map(hashtag => <span className="recommeded-value" onClick={() => this.handleClickRecommendedHashTag(hashtag)}>{`${hashtag}`}</span>)
                            }
                        </div>

                        <div className="edit-hashtag-dialog-bottom-container">
                            <button color='primary' width='80px' height='30px' onClick={onClose}>{i18n.t("global.close")}</button>
                            <button color='primary' width='80px' height='30px' onClick={onConfirm}>{i18n.t("global.change")}</button>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(EditHashTagDialog)